/** Created by azhou on 2019/3/1.*/
<template>
  <div class="mt-4">
    <!--定向订单信息-->
    <div v-if="appointHotel" class="mb-3">
      <div class="d-center-start">
        <left-text leftText="预订酒店" :width="60" />
        <span class="bg-login text-white p-2 rounded">{{DisplayBasicInfo.title}}</span>
        <!-- <span class="text-info ml-3">{{DisplayBasicInfo.star | formatVar('HotelStar')}}</span>
        <span class="text-muted ml-3">（{{DisplayBasicInfo.province_name + DisplayBasicInfo.city_name + DisplayBasicInfo.district_name}}）</span> -->
      </div>
    </div>
    <!--@input="teamcurrent=-1"-->
    <div class="d-center-start mb-3">
      <left-text leftText="团队类型" :width="60"/>
      <div class="d-center-start el-selectq">
          <el-select v-model="postInfo.team_type" slot="prepend" placeholder="请选择" :disabled="true">
          <el-option label="旅游团" value="1"></el-option>
          <el-option label="会议团" value="2"></el-option>
        </el-select>
        <el-input :disabled="true" v-model="postInfo.title" :restaurants="postInfo.team_type==1?teams:teamsto"></el-input>
      </div>
    </div>
    <select-city class="mb-3 form-width"
                 :width="60"  
                 leftText="目的地"
                 mutiBlocks
                 v-if="!appointHotel&&modify"
                 @getCityInfo="getCityInfo"
                 :provinceId="postInfo.province"
                 :cityId="postInfo.city"
                 :districtIds="postInfo.county"/>
    <!--客房需求相关-->
    <div class="d-center-start mb-3">
      <div class="d-center-start form-width bjys">
        <left-text leftText="入住/离店"  :width="60"/>
        <div class="Ordersmall">
          <div>
            <span  class="huis" v-if="!timestamp[0]">入住日期</span>
            <span v-else>{{timestamp[0]/1000| formatTimestamp(5)}}</span>
          </div>
          <p>至</p>
          <div>
            <span class="huis" v-if="!timestamp[1]">离店日期</span>
            <span v-else>{{timestamp[1]/1000| formatTimestamp(5)}}</span>
          </div>
          <!-- <span @click="timestamp=[]" v-if="timestamp.length!=0">x</span> -->
            <!-- <el-date-picker v-model="timestamp" size="small" 
            type="daterange"
            class="w-100  nnsqs"
            range-separator="至"
            value-format="timestamp"
            :picker-options="modify?pickerOptions:''"
            start-placeholder="入住日期"
            :format="'yyyy年MM月dd日'" 
            end-placeholder="离店日期" /> -->
        </div>
      </div>
      <span class="ml-3" v-show="totalNum>0">共入住 <span class="text-danger">{{totalNum}} </span>晚</span>
    </div>
    <div class="d-center-start mb-3 form-width">
      <left-text leftText="入住人数"  :width="60"/>
      <el-input :disabled="true" type="number" @mousewheel.native.prevent style="width: 90px;" v-model.number="postInfo.num" placeholder="人数"><span slot="append">人</span></el-input>
    </div>
    <div class="d-center-start mb-3" v-if="modify">
      <left-text leftText="早餐需求"  :width="60"/>
      <el-radio-group v-model="postInfo.breakfast" class="d-center-start">
        <el-radio :label="item.id" :key="item.id" class="ml-0 mr-3"
                  v-for="item in $GVAR.breakfastArr">{{item.name}}
        </el-radio>
      </el-radio-group>
    </div>
    <div class="d-center-start mb-3" v-if="!modify">
      <left-text leftText="早餐提供"  :width="60"/>
      <el-radio-group v-model="postInfo.breakfast_type" class="d-center-start">
        <el-radio :label="item.id" :key="item.id" class="ml-0 mr-3" :disabled="true"
                  v-for="item in $GVAR.breakfastArr">{{item.name}}
        </el-radio>
      </el-radio-group>
    </div>
    <!--用房需求-->
    <div class="d-center-start mb-3">
      <left-text leftText="用房需求"  :width="60"/>
      <div class="text-left  tems flis margleft-0"  v-if="modify">
        <span 
          v-for="item in priceArr" 
          :key="item.value"
          :class="item.shos==1&&'active'"
          @click="item.shos==0?item.shos=1:item.shos=0"
          >{{item.label}}</span>
      </div>
      <div  v-if="!modify&&!datePattern" :class="!datePattern&&'luis'" class="blieDne mr-2" >正常住宿</div>
      <div  v-if="!modify&&datePattern" :class="datePattern&&'luis'" class="blieDne" >多晚住宿</div>
    </div>
    <!-- <div class="d-center-start mb-3" v-if="!datePattern&&!modify">
      <left-text leftText=""/>
      <div class="text-left  tems flis margleft-0">
        <span 
          v-for="item in priceArr" 
          :key="item.value"
          :class="item.shos==1&&'active'"
          @click="item.shos==0?item.shos=1:item.shos=0"
          >{{item.label}}</span>
      </div>
    </div> -->
    <!--用房需求-->
    <div class=" mb-3 lislet" v-if="!datePattern">
      <template v-for="(item,index) in priceArr" >
        <div class="text-left mb-3 pl"  :key="item.value" v-if="item.shos==1">
            <p class="righttext">{{item.label}}</p>
            <el-input  type="number" v-model.number="item.room_num" @mousewheel.native.prevent class="w-16" placeholder="间数">
              <span slot="append">间</span>
            </el-input>
            <!-- <el-input type="number" v-model.number="item.night_num" @mousewheel.native.prevent class="w-16 pl-2"  v-if="!modify" placeholder="晚数">
              <span slot="append">晚</span>
            </el-input> -->
            <el-select class="w-20 mr-3 mr-49 pl-2"
                        v-model="item.offer_title"
                        @change="getId($event,index,1)"
                        @blur="blurs($event,index,1)"
                        :filterable="true"
                        allow-create
                        default-first-option
                        placeholder="请选择或输入房型"
                        :disabled="true"
                        v-if="!modify"
                        >
              <template v-for="roomItem in StoreRoomArr.meetArr" >
                <el-option 
                          v-if="item.type<=3?item.type==roomItem.type:true"
                          :key="roomItem.title"
                          :label="roomItem.title"
                          :value="`${roomItem.id},${roomItem.title}`">
                </el-option>
              </template>
            </el-select>
            <p class="pl-2" v-if="!modify">单价</p>
            <el-input placeholder="金额" class="w-28 mr-2 price" type="number" v-if="!modify"
                      v-model.number="item.offer_price">
              <span slot="prepend">&yen;</span>
              <span slot="append" class="lisxn">元/晚</span>
            </el-input>
            <i class="el-icon-close close" @click="priceArrShos(index,item.shos)"></i>
        </div>
      </template>
    </div>
    <!--用房需求日期模式-->
    <FomsMode v-if="datePattern" :disabled="true" :timestamp="timestamp" :totalNum="totalNum" @Pattern='datePattern=false' @datePrompt='datePrompt' :priceArr='priceArr' :need_mode='OrderDetail.need_mode' :room_need_arr='OrderDetail.room_need_arr'></FomsMode>
    <div  v-if="!modify">
      <!--客房需求相关-->
      <div class="d-start-start mb-3">
        <left-text leftText="会议需求"  :width="60"/>
        <div class="meeting" v-if="meetObj.length>0">
          <span   class="w-1p mr-1" v-for="(item,index) in meetingname" :key="index">{{item}}</span>
          <span   class="w-2p mr-1">出席人数</span>
          <span   class="w-2p mr-1">要求面积</span>
          <span   class="w-3p mr-1" v-if="!modify">名称</span>
          <span   class="w-28 mr-1" v-if="!modify">价格</span>
        </div>
        <div v-if="meetObj.length<=0" style="width: 0;">
          无
        </div> 
      </div>
      <template v-for="(item,index) in meetObj"> 
        <div class=" el-checkbox-group d-center-start flex-wrap p-2 nsl" v-if="meetObj.length>0"  :key="index">
          <el-date-picker v-model="item.date"
                          type="date" 
                          class="w-1p mr-1"
                          :disabled="true"
                          value-format="timestamp"
                          :picker-options="startDateLimit"
                          placeholder="选择日期"/>
          <el-select v-model="item.timeslot" class="w-1p mr-1" :disabled="true">
            <el-option v-for="item in $GVAR.TimeSlots"
                      :key="item.name"
                      :label="item.name"
                      :value="item.id"/>
          </el-select>
          <el-select v-model="item.type" class="w-1p mr-1" :disabled="true">
            <el-option v-for="item in $GVAR.LayoutTypes"
                      :key="item.name"
                      :label="item.name"
                      :value="item.id"/>
          </el-select>
          <el-input type="number" v-model.number="item.num" @mousewheel.native.prevent class="w-2p mr-1" placeholder="人数" :disabled="true">
              <span slot="append">人</span>
          </el-input>
          <el-input type="number" v-model.number="item.area" @mousewheel.native.prevent class="w-2p mr-1" placeholder="面积" :disabled="true">
              <span slot="append">㎡</span>
            </el-input>
            <el-select class="w-3p mr-1 mr-49" 
                      v-model="item.id"
                      :disabled="true"
                      ref="selectItems"
                      @change="getId($event,index,2)"
                      @blur="blurs($event,index,2)"
                      filterable
                      allow-create
                      default-first-option
                      :placeholder="item.offer_title||'请选择或输入会议室'"
                      v-if="!modify"
            >
              <el-option 
                  v-for="roomItem in StoreMeetArr"
                  :key="roomItem.title"
                  :label="roomItem.title"
                  :value="`${roomItem.id},${roomItem.title}`">
              </el-option>
          </el-select>
          <el-input placeholder="金额" class="w-28 mr-1 price" type="number" v-if="!modify" 
                    v-model.number="item.offer_price">
            <span slot="prepend">&yen;</span>
            <span slot="append" class="lisxn">元</span>
          </el-input>
        </div>
      </template>
    </div>
     <!--修改订单附加需求相关-->
     <div  v-if="!modify">
      <div class="d-start-start mb-3">
        <left-text leftText="附加需求"  :width="60"/>
        <div class="meeting" v-if="add_need.length>0">
          <span   class="w-3p mr-1">名称</span>
          <span   class="w-1p mr-1">金额</span>
        </div>
        <div v-if="add_need.length<=0" style="width: 0;">
          无
        </div>  
      </div>
        <div class=" el-checkbox-group d-center-start flex-wrap p-2 nsl"  v-for="(item,index) in add_need" :key="index">
            <el-select class="w-3p mr-1 mr-49" 
                    v-model="item.id"
                    @change="getId($event,index,3)"
                    @blur="blurs($event,index,3)"
                    filterable
                    allow-create
                    default-first-option
                    :placeholder="item.add_title||'请选择或输入名称'"
                    :disabled="true"
                    v-if="!modify"
              >
                <el-option
                    :disabled="true" 
                    v-for="roomItem in add_name"
                    :key="roomItem.title"
                    :label="roomItem.title"
                    :value="`${roomItem.id},${roomItem.title}`">
                </el-option>
            </el-select>
            <el-input placeholder="金额" class="w-28 mr-1 price" type="number"
                      v-model.number="item.add_price">
              <span slot="prepend">&yen;</span>
              <span slot="append" class="lisxn">元</span>
            </el-input>
      </div>
    </div>
    <!--会议室需求-->
    <div class="d-center-start mb-3" v-if="modify">
      <left-text leftText="会议需求"  :width="60"/>
        <el-checkbox  v-for="(item,index) in meetRoomObj"  v-model="item.meets" :key="index">{{item.name}}</el-checkbox>
    </div>

    <div class="d-center-start mb-3 form-width" v-if="!modify">
      <left-text leftText="订金"  :width="60"/>
      <el-input :disabled="true" type="number" @mousewheel.native.prevent style="width: 100px;" v-model.number="postInfo.deposit"><span slot="append">元</span></el-input>
    </div>
    <left-text-border class="mb-3 form-width"
                      leftText="报价说明"
                      :width="60"
                      :disabled="true"
                      placeholder="可输入订单需求备注"
                      type="textarea"
                      v-model="postInfo.remark"/>
    <div class="d-center-start mb-3" v-if="modify">
      <left-text leftText="联系人"  :width="60"/>
      <label class="text-muted">
        {{orderPostPre.truename}}（{{orderPostPre.mobile}}）
        <!-- — {{orderPostPre.title}}（{{orderPostPre.telephone || '空'}}） -->
      </label>
    </div>
    <el-button class="mt-4" type="success" @click="goBack" v-if="!modify">返回</el-button>
    <div class=" mt-4 hs  ml-3"  @click="validateForm(0)" v-if="!modify&&invoicing_change==1">设置代订收款</div>
    <el-dialog title="确认订单" :visible.sync="showConfirmPanel" width="50%" center id="loadConfirm">
      <confirm-panel :postInfo="postInfo" :cityName="cityName" :priceArrs='priceArr'/>
      <div slot="footer">
        <el-button size="small" @click="showConfirmPanel = false">返回修改</el-button>
        <el-button size="small" type="primary" @click="submitPost">确认发布</el-button>
      </div>
    </el-dialog>
    <div class="botext">设置代订收款后，不会影响原订单内容，只作为对外展示内容</div>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import ConfirmPanel from '../ConfirmPanel'
  import FomsMode from '../MeetOrder/FomsMode'
  export default {
    name: 'PostRoomOrder',
    components: { ConfirmPanel,FomsMode},
    computed: {
      ...mapState(['orderPostPre','DisplayBasicInfo','StoreLists','OrderDetail','StoreRoomArr','StoreMeetArr']),
      ...mapGetters(['storeInfo','isGroup']),
      //入住日期开始时间戳
      startDateLimit () {
        let modify=this.modify;
        return {
          disabledDate (time) {
          let n=modify?time.getTime() < Date.now() - 8.64e7:'';
            return n;
          },
        }
      },
      //共入住间夜数
      totalNum () { 
        return (this.postInfo.date_out - this.postInfo.date_in) / 86400 
      },
      //用房需求总数
      totalRoom () {
        let total = 0
        this.priceArr.forEach(v => total += Number(this.postInfo[v.value]))
        return total;
      },
      //订单类型
      orderType () {
        if (this.totalNum > 0 && this.needMeets) {
          return '3'
        } else if (this.totalNum) {
          return '3'//1
        } else if (this.needMeets) return '2'
        return ''
      },
      //路由中的酒店ID，存在时判断为定向订单
      appointHotel() { return this.$route.query.hotel },
      //是否设置支付人
      pay_arr() { return this.$route.query.pay_arr},
      //是否是代订收款修改
      invoicing_change() { return this.$route.query.invoicing_change},
    },
    data () {
      return {
         pickerOptions: {
          onPick: ({ maxDate, minDate }) => {
            if (minDate && !maxDate) {
              this.timeOptionRange = minDate
            }
            if (maxDate) {
              this.timeOptionRange = null
            }
          },
          disabledDate: (time) => {
            // 获取选中时间
            let timeOptionRange = this.timeOptionRange
            let dayRange = 1 * 24 * 60  * 1000;
            if (timeOptionRange) {
              return time.getTime() < Date.now() - 8.64e7 || time.getTime() === timeOptionRange.getTime() || time.getTime() === timeOptionRange.getTime() + dayRange || time.getTime() === timeOptionRange.getTime() - dayRange
            }else{
              return time.getTime() < Date.now() - 8.64e7
            }
          }
        },
        modify:true,   //修改隐藏
        postInfo: {
          isFocused:true,
          order_type:1,
          team_type:'1',
          title: '',
          province: '',
          city: '',
          county: [],
          star: [],
          room_need:[],
          date_in: '',
          date_out: '',
          breakfast:-1,
          // queen_room: '',
          // standard_room: '',
          // triple_room: '',
          // department_room: '',
          room_num: '',
          meeting_mess: [],
          meeting_need:[],
          // tea_break: false,
          // is_meal: 0,
          other:'',
          remark: '',
          district:'',
          appoint_store_id:'',
          add_need:[],
        },
        dialogVisible: false,
        search: '',
        current: -1,
        total: 0,
        page: 1,
        chooseTravel: {},
        url: 'pc/Travel/getStoreMaterial',
        timestamp: [],
        priceArr: [
          { label: '大床房', value: 'queen_room',shos:0,type:1,room_num:'',offer_price:'',offer_id:'',offer_title:'',id:'',night_num:''},
          { label: '双床房', value: 'standard_room',shos:0,type:2,room_num:'',offer_price:'',offer_id:'',offer_title:'',id:'',night_num:''},
          { label: '三床房', value: 'triple_room',shos:0,type:3,om_num:'',offer_price:'',offer_id:'',offer_title:'',id:'',night_num:''},
          { label: '亲子房', value: 'department_room',shos:0,type:4,rom_num:'',offer_price:'',offer_id:'',offer_title:'',id:'',night_num:''},
          { label: '套房', value: 'department_rooms',shos:0,type:5,om_num:'',offer_price:'',offer_id:'',offer_title:'',id:'',night_num:''},
        ],
        needMeets: false,
        meetRoomObj: [
          {name:'会议室',meets:false,id:'1'},
          {name:'LED',meets:false,id:'2'},
          {name:'投影仪',meets:false,id:'3'},
          {name:'茶歇',meets:false,id:'4'},
          {name:'餐饮',meets:false,id:'5'},
          {name:'搭建',meets:false,id:'6'},
        ],
        meetObj:[],                                                                                   //修改会员需求组
        meetObjfs:[{ date: '', timeslot: '', num: '',area:'', type: '',offer_title:'',offer_price:''}],                        //添加会员需求组的内容
        add_need:[],                                                                                  //添加附加需求组
        add_needs:[{add_title:'',add_price:'',}],                                                     //添加附加需求组的内容
        add_name:[{title:'会场费',id:0},{title:'餐费',id:1},{title:'其他',id:2}],
        showConfirmPanel:false,
        cityName:{},
        teams: [ { "value": "散客班"},{ "value": "疗养团"},{ "value": "老年团"},{ "value": "亲子团"},{ "value": "研学团"},{ "value": "外宾团"},{ "value": "成人团"}],
        teamsto: [
          { "value": "年会"},
          { "value": "工作会/总结会"},
          { "value": "同学会/好友聚会"},
          { "value": "答谢会"},
          { "value": "发布会/颁奖/庆典"},
          { "value": "OUTING/会奖"},
          { "value": "培训/讲座"},
          { "value": "研讨/交流/论坛"},
          { "value": "经销商会议/招商会/推介会"},
          { "value": "团队建设/拓展/休闲会议"},
          { "value": "沙龙"},
        ],
        dumpling: [
          {name: '旅游团',},
          {name: '会议团',},
        ],
        meetingname:[
          '开会日期','时段','布局',
        ],
        meetingnametwo:[
          '开会日期','时段','布局',
        ],
        lis:0,
        teamcurrent: -1,
        datevalue:[],                //日期模式值
        datePattern:false,
      }
    },
    filters:{
      lineBreak:function(data){
        return data.replace(/<br>/g,'\n');
      }
    },
    watch: {
      //入住和离店日期戳
      timestamp (newVal) {
        this.postInfo.date_in = newVal[0] / 1000;
        this.postInfo.date_out = newVal[1] / 1000
      },
      //是否需要会议室
      needMeets (newVal) {
        if (!newVal) this.postInfo.meeting_mess = [];
      },
      //采购商重发订单和管理员编辑订单时订单的信息
      OrderDetail(newVal) {
        if (!$.isEmptyObject(newVal)) {
          this.modify=false;                                                //开启修改功能
          this.getRoomLists(newVal.offer_store_id)                          //获取门店房间列表
          this.getMeetLists(newVal.offer_store_id)                          //获取会议室房间列表
          newVal.star=newVal.star.split(',');                               //会议需求
          newVal.city=newVal.city*1,newVal.province=newVal.province*1,newVal.breakfast=newVal.breakfast*1,newVal.breakfast_type=newVal.breakfast_type*1;     //省市
          newVal.district=newVal.district.split(',');
          newVal.district_name=newVal.district_name.split(',');                     
          newVal.county=newVal.district.map(v => v*1);                     //地区
          this.timestamp.push(newVal.date_in*1000);                        //入驻时间开始
          this.timestamp.push(newVal.date_out*1000);                       //入驻时间结束
          this.postInfo={...newVal};
          this.postInfo.order_type=1;                                      //切换修改订单类型
          // this.priceArr= newVal.room_need_arr;
          if(newVal.need_mode==1) this.datePattern=true;                   //修改为日期模式
          console.log(newVal.room_need_arr);
          for(let i in  this.priceArr){
            for(let n in newVal.room_need_arr){
              if(this.priceArr[i].type==newVal.room_need_arr[n].type){
                this.priceArr[i].room_num=newVal.room_need_arr[n].room_num;
                this.priceArr[i].id=newVal.room_need_arr[n].id?newVal.room_need_arr[n].id.toString():newVal.room_need_arr[n].offer_title;
                this.priceArr[i].offer_id=newVal.room_need_arr[n].offer_id.toString();
                this.priceArr[i].night_num=newVal.room_need_arr[n].night_num;
                this.priceArr[i].offer_price=newVal.room_need_arr[n].offer_price;
                this.priceArr[i].offer_title=newVal.room_need_arr[n].offer_title;
                this.priceArr[i].shos=1;
              }
            }
          }
          for(let i in newVal.meeting_need_arr){
            newVal.meeting_need_arr[i].date=newVal.meeting_need_arr[i].date*1000;
          }                                                                
          this.meetObj=newVal.meeting_need_arr                             //会议需求
          this.add_need=newVal.add_need_arr                                //附加需求
          for(let i in this.meetRoomObj){                                  //酒店星级
            let other=newVal.other;
                if(other.indexOf(this.meetRoomObj[i].id)!=-1){
                  this.meetRoomObj[i].meets=true;
                }
          }
          this.cityName = {                                               //省市区文字描述
            province_name:this.postInfo.province_name,
            city_name:this.postInfo.city_name,
            district:newVal.district.map((v,index) => {
              return {id:v,name:newVal.district_name[index]}
            })
          }
        }
      },
    },
    beforeDestroy() { this.UPDATECURRENTSTORE({ storeId: '' }) },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getMeetLists','getRoomLists','GetOrderDetail','travelPostOrderPre','travelPostOrder','adminEditOrderPre','adminEditOrder','GetDisplayInfo','TraGroupGetStoreLists','travelRecipient']),
      //开启或关闭用房需求
      priceArrShos(index,shos){
        console.log(index,shos);
        let arr={room_num:'',offer_price:'',offer_id:'',offer_title:'',id:'',night_num:''};
        let price=this.priceArr[index];
        if(shos==1){
          price={
            ...price,
            ...arr
          }
          price.shos=0;
        }else{
          price.shos=1;
        }
        this.$set(this.priceArr,index,price);
      },
      //普通模式
      ordinary(){
        this.datePattern=false;
        let priceArr=JSON.parse(JSON.stringify(this.priceArr)),datevalue=[],vueli=[];
        datevalue=this.datevalue.map(item=>{
          return item.offer_info.map(date=>{
            return date
          })
        })
        datevalue.map(item=>{
          item.map(i=>{
            vueli.push(i)
          })
        })
        for(let i in priceArr){
            const firstItemAbove24 = vueli.find(item => item.type==priceArr[i].type);
            if(firstItemAbove24){
              let data={
                ...priceArr[i],
                ...firstItemAbove24,
                shos:1,
                night_num:this.totalNum,
                label:priceArr[i].label
              }
               this.$set(this.priceArr,i,data)
            }
        }
      },
      //获取日期模式值
      datePrompt(data){
        this.datevalue=data;
        // console.log(this.datevalue);
      },
      //返回上一页面
      goBack() {
        this.$router.go(-1); 
      },
      //添加一条会议需求
      addMeeting(){
        let data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs[0])));
        this.meetObj.push(data)
        //this.$set(this.meetObj,this.meetObj.length, this.meetObjfs);
        //this.meetObj.push(this.meetObjfs);
      },
      //添加一条附加需求
      addNeed(){
        let data = Object.assign({}, JSON.parse(JSON.stringify(this.add_needs[0])));
        this.add_need.push(data)
      },
            //获取选中值
      switchID(p){
        let n;
        switch (p) {
            case 1:
                n=this.priceArr;
                break;
            case 2:
                n=this.meetObj;
                break;
            case 3:
                n=this.add_need;
                break;
            default:
                break;
        }
        return n
      },
      // 获取选中的id
      splicse(index,p){
        let n=this.switchID(p);
        n.splice(index,1);
      },
      // 获取选中的id
      getId(val,index,p){
          let n=this.switchID(p),room_offer={};
          let [id, name] = val.split(',');
            if(p==3){
              room_offer={...n[index],add_title:name?name:id}
            }else{
              room_offer={...n[index],offer_id:name?id:'0',offer_title:name?name:id}
            }
            console.log(room_offer)
            this.$set(n,index,room_offer);
      },
       blurs(val,index,p){
        console.log('2')
        let n=this.switchID(p),room_offer={};
        if(val.target.value){
          if(p==3){
            room_offer={...n[index],id:val.target.value,add_title:val.target.value}
          }else{
            room_offer={...n[index],id:val.target.value,offer_id:'0',offer_title:val.target.value}
          }
          this.$set(n,index,room_offer)
        }
      },
      enSure () {
        this.UPDATECURRENTSTORE({ storeId: this.chooseTravel.store_id })
        this.dialogVisible = false
      },
      getTravelList (search) {
        if (search) this.TraGroupGetStoreLists({ url: this.url, data: {page: 1,title: this.search} })
        else this.TraGroupGetStoreLists({ url: this.url, data: {title: this.search} })
      },
      choose (item, index) {
        this.chooseTravel = {}; this.chooseTravel = item; this.current = index
      },
      //获取省市区id
      getCityInfo (info) {
        this.postInfo.province = info.province;
        this.postInfo.city = info.city;
        this.postInfo.county = info.district.map(v => v.id);
        this.cityName = info;
      },
      //验证添加会议室
      validateAddMeet () {
        if (!this.meetRoomObj.date) return { code: false, msg: '请选择会议时间' }
        if (this.meetRoomObj.num <= 0) return { code: false, msg: '请填写会议人数' }
        return { code: true, msg: '验证通过' }
      },
      /*添加会议室需求*/
      addMeet () {
        let res = this.validateAddMeet()
        if (res.code) {
          let obj = {
            ...this.meetRoomObj,
            date: this.meetRoomObj.date / 1000,
            led: this.meetRoomObj.led ? '2' : '1',
            projector: this.meetRoomObj.projector ? '2' : '1',
          }
          this.postInfo.meeting_mess.push(obj)
        } else this._alert(res.msg, null, 'error')
      },
      /*验证表单*/
      validateForm(flag) {
          let room_need=0,other=[],priceArr=[],evening=0,room=0;//是否填写用房需求
          priceArr=this.priceArr.filter(todo=>todo.shos==1);
          for(let i in priceArr){
            if(priceArr[i].room_num==0||priceArr[i].room_num==''){
              room_need++
            }
          }
          if(!this.modify){
            for(let i in priceArr){
              if(priceArr[i].offer_price==0){
                evening++
              }
            }
            for(let i in priceArr){
              if(priceArr[i].offer_title==''){
                room++
              }
            }
          }
          for(let i in this.meetRoomObj){
            if(this.meetRoomObj[i].meets==true){
              other.push(this.meetRoomObj[i].id)
            }
          }
          this.postInfo.other=other||'';
          //验证表单完成性
          let meetObj=JSON.parse(JSON.stringify(this.meetObj));
          const allValuesNotEmpty = meetObj.every((obj) => {
              delete  obj.offer_id;
              return Object.values(obj).every((value) => {return value!==""&&value!==0});
          });
          //验证日期表单完成性
          const datevalue = this.datevalue.every((obj) => {
              if(obj.date=="") return false;
              let n=obj.offer_info.every((date) => {
                return Object.values(date).every((value) => value!==""&&value!==0);
              })
              return n;
          });
              console.log(this.datevalue);
          //验证附件信息表单完成性
          const add_needvalue = this.add_need.every((obj) => {
              return Object.values(obj).every((value) => value !== ""&&value!==0);
          });
          console.log(this.meetObj,7788);
        let res = (() => {
          //if (this.isGroup && JSON.stringify(this.chooseTravel) == '{}') return { code: false, msg: '集团用户请选择采购商' }
          if (!this.postInfo.title)  return { code: false, msg: '请选择或填写团号' };
          if (this.postInfo.county.length <= 0) return { code: false, msg: '请选择订单目标区域'};
          if (this.postInfo.star.length <= 0) return { code: false, msg: '请选择酒店星级'};
          if (this.totalNum <= 0) return { code: false, msg: '请选择入住日期和离店日期'};
          if (priceArr.length<=0&&!this.datePattern) return { code: false, msg: '请添加一条用房需求信息'};
          if (this.priceArr.length<=0&&!this.datePattern) return { code: false, msg: '请输入正确的入住人数' };
          if (!this.$GFUN.isPositiveInteger(this.postInfo.num)) return { code: false, msg: '请输入正确的入住人数' };
          if(!this.datePattern){
              console.log(evening);
              if (room_need>0) return { code: false, msg: '房间数量不正确' };
              if (evening>0&&!this.modify) return { code: false, msg: '房间单价为空或为0'};
          }
          console.log(this.datevalue,datevalue)
          if (this.datevalue.length<=0&&!this.modify&&this.datePattern) return { code: false, msg: '请添加一条用房需求信息'};
          if (!datevalue&&!this.modify&&this.datePattern) return { code: false, msg: '请添写完整的用房需求信息(或间数金额为0)'};
          if (!allValuesNotEmpty&&!this.modify) return { code: false, msg: '请添写完整的会议需求信息(或人数面积为0)'};
          if (!add_needvalue&&!this.modify) return { code: false, msg: '请添写完整的附加需求(或金额为0)'}; 
          if (room>0&&!this.modify) return { code: false, msg: '房间房型不正确'};
          if (this.postInfo.breakfast<0) return { code: false, msg: '请选择早餐需求'};
          return { code: true, msg: '验证通过' }
        })();
        if (res.code) this.modify?this.showConfirmPanel = true:this.modifyPost(flag);
        else this._alert(res.msg, null, 'error');
      },
      /*修改订单*/
      modifyPost(flag){
        for(let i in this.priceArr){this.priceArr[i].night_num=this.totalNum}
        this._confirm('不影响原订单内容，只作为代订收款内容对外展示！',() => {
            let room_need=!this.datePattern?this.priceArr.filter(todo=>todo.room_num!=0&&todo.shos==1):this.datevalue.map((item)=>{item.date=item.date/1000;return item}) //普通模式值/日期模式值
            if(this.meetObj.length!=0){
              let lies=JSON.parse(JSON.stringify(this.meetObj));
              lies.forEach((item)=>{
                  item.date=item.date/1000
              })
              this.postInfo.meeting_need=JSON.stringify(lies);
            }
            if(this.add_need.length!=0){this.postInfo.add_need=JSON.stringify(this.add_need);}
            if(this.postInfo.length!=0){
              this.postInfo.other=this.postInfo.other.join(',')
            }
            this.postInfo.room_need=JSON.stringify(room_need);
            this.postInfo.district=this.postInfo.county.join(',')
            this.postInfo.star=this.postInfo.star.join(',');
            delete  this.postInfo.county;
            delete  this.postInfo.room_need_arr;
            delete  this.postInfo.district_name;
             delete  this.postInfo.district_name;
            //如果是收款修改调取另一个方法
            if(this.invoicing_change==1){
              console.log(this.invoicing_change)
                this.PsotTravelRecipient(flag)
                return
            }
            //正常修改订单
            this.travelPostOrder({
              data:{
                ...this.postInfo,
                need_mode:this.datePattern?1:0,
                modify:this.modify,
                flag:flag,
              },
              successFun:() => {
                //修改提示文字
                this._alert('设置待收款订单成功',() => {
                  this.$router.go(-1);
                  // if (this.appointHotel)  this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}})
                  // else this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}}) 
                })
              }
            }); 
        });
      },
      //提交收款人修改
      PsotTravelRecipient(flag){
        console.log(this.postInfo);
        this.travelRecipient({
          data:{
            ...this.postInfo,
            flag:flag
          },
          successFun:() => {
            //修改提示文字
            this.showConfirmPanel = false;
            this._alert('设置收款订单成功',() => {
              this.$router.go(-1);
              // if (this.appointHotel)  this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}})
              // else this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}}) 
            })
          }
        }); 
      },
       /*发布订单*/
      submitPost() {
        this.priceArr=this.priceArr.filter(todo=>todo.room_num!=0&&todo.shos==1);
        this.priceArr.map(todo=>{
          todo.night_num=this.totalNum
          return todo
        });
        this.postInfo.room_need=JSON.stringify(this.priceArr);
        if(this.postInfo.length!=0){
          this.postInfo.other=this.postInfo.other.join(',')
        }
        this.postInfo.district=this.postInfo.county.join(',');
        this.postInfo.star=this.postInfo.star.join(',');
        delete  this.postInfo.county;
        delete  this.postInfo.room_need_arr;
        delete  this.postInfo.district_name;
        switch (this.storeInfo.type) {
          case 2: 
            this.travelPostOrder({
              data:{
                ...this.postInfo,
                // tea_break:this.postInfo.tea_break ? '1' : '0',
                modify:this.modify,
              },
              successFun:() => {
                this.showConfirmPanel = false;
                this._alert('订单发布成功',() => {
                  if (this.appointHotel)  this.$router.push({name:'OrderLists',query:{orderStatus:'4',page:1,orderType:3}})
                  else this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}}) 
                })
              },
              successNone:(msg)=>{
                this.showConfirmPanel = false;
                this._alert(msg,() => {
                    this.$router.go(-1);
                })
              }
            }); 
          break;
          case 99 :
            this.adminEditOrder({
            data:{
              ...this.postInfo,
              tea_break:this.postInfo.tea_break ? '1' : '0',
              order_type:this.orderType
            },
            successFun:() => {
              this.showConfirmPanel = false;
              this._alert('订单编辑成功',() => { this.$router.push({name:'OrderDetail',query:{orderType:3,orderId:this.postInfo.id}}) })
            }
          }); break;
        }
      }
    },
    created () {
      if(this.$route.query.type=='住宿订单'&&this.$route.query.orderId){
        this.GetOrderDetail(this.$route.query.orderId);
      }
      switch (this.storeInfo.type) {
        case 2:this.travelPostOrderPre(this.$route.query.orderId); break;
        case 99:this.adminEditOrderPre(this.$route.query.orderId); break;
      }
      //定向订单的页面赋值
      if (this.appointHotel) {
        console.log(this.DisplayBasicInfo);
        //获取指定酒店的详细信息
        this.GetDisplayInfo({
          type:'3',
          data:{id:this.appointHotel},
          successFun:(e) => {
            this.postInfo.appoint_store_id = this.appointHotel;
            this.postInfo.hotel_id = this.appointHotel;
            this.postInfo.province = e.province;
            this.postInfo.city = e.city;
            this.postInfo.county.push(e.district);
            this.postInfo.star.push(e.star);
            this.cityName = {
              province_name:e.province_name,
              city_name:e.city_name,
              district:[{id:e.district,name:e.district_name}]
            }
          }
        });
      }
    }
  }
</script>
<style lang="scss" >
  .form-widtht{
    width: 574px;
    text-align:center;
    .nis{
      font-size: 24px;
color: var(--smtc-color-primary); 
      margin: 0 auto;
      cursor: pointer;
    }
  }
  .closes{
    i{
      font-size: 20px;
      color: #db2928 !important;
      cursor: pointer;
    }
  }

  .w-16{
    width: 90px;
  }
  .lislet{
    margin-left: 120px;
    overflow: hidden;
    width: 800px;
  }
  .righttext{
    text-align: right;
    min-width: 40px;
  }
  .lis-l{
    float: left;
    width: 100%;
  }
  .ovhts{
    overflow: hidden;
  }
  .huis{
    color: #C0C4CC;
  }
  .flis,.nisp{
    float: left;
  }
  .pl p{
    display: inline-block;
    margin:0 5px;
  }
  .w-28{
    width: 130px !important;
  }
  .w-16 .el-input__inner,.w-28 .el-input__inner{
    text-align: center;
    padding: 0 6px;
  }
  .Ordersmall{
      width: 100%;
      background-color: #f5f7fa;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #caced5;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: none;
      padding: 0 2%;
      font-size: 12px;
      position: relative;
  }
  .Ordersmall p{
    float: left;
    width: 14%;
    text-align: center;
  }
  .Ordersmall div{
    float: left;
    width: 40%;
    text-align:center;
  }
  .Ordersmall div>span{
    width: 100%;
  
  }
  .Ordersmall>span{
    border: 1px #df3e3d solid;
    width: 12px;
    height: 12px;
    font-size: 10px;
    text-align:center;
    line-height: 12px;
    border-radius: 50px;
    color: #df3e3d;
    float: left;
    display: block;
    margin-top: 13px;
    position: relative;
    z-index: 99;
    cursor: pointer;
  }
  .nnsqs{
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0.0;
      z-index: 9;
  }
  .mincontent{
    height: 40vh;
  }
  .room-need-item {
    background: rgba(0, 123, 255, 0.1);
    padding: 5px 10px;
    text-align: center;
    &:hover {
      background: rgba(0, 123, 255, 0.3);
    }
    border-radius: 3px;
    cursor: default;
  }
  .tems{
    margin-left: 81px;
    span{
      border: 1px solid #eee;
      padding: 6px 14px;
      border-radius: 5px;
      margin-right: 6px;
      color: #919191;
      cursor: pointer;
      font-size: 12px;
      display: block;
      float: left;

    }
    .active{
      border: 1px solid  #61DAF3;
      color:  #61DAF3
    }
  }
  .margleft-0{
    margin-left: 0;
  }
  .close{
    color: #df3e3d;
    border: 1px #df3e3d solid;
    border-radius: 50px;
    padding: 3px 2px 2px 2px;
    margin-left: 6px;
    cursor: pointer;
  }
  .botext{
    color: #df3e3d;
    margin-top: 14px;

  }
  .npsl{
    span{
      border: 1px solid #eee;
      padding: 10px  20px 10px 30px;
      border-radius: 5px;
      margin-right: 10px;
      color: #919191;
      cursor: pointer;
      display: block;
      float: left;
      text-align: justify;
      letter-spacing: 10px;
    }
    .active{
      border: 1px solid  #61DAF3;
      color:  #61DAF3
    }
  }
  .hs{
    background-color: #ff8907;
    border: 1px #ff8907 solid;
    color: #fff;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
  }
  .hs:hover{
    background-color: #fa9424;
    border: 1px #fa9424 solid;
  }
  .meeting{
    float: left;
  }
  .el-input__inner{
    height: 40px !important;
  }
  .meeting span{
    text-align: center;
    display: inline-block;
  }
  .w-1p{
    width: 136px !important;  
  }
  .w-3p{
    width: 175px !important;  
  }
  .w-4p{
    width: 200px !important;  
  }
  .w-2p{
    width: 90px;
  }
  .nsl{
    margin-left: 75px;
  }
  .blieDne{
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 36px;
    line-height: 36px;
    outline: none;
    padding: 0 2%;
    font-size: 12px;
    position: relative;
    cursor: pointer;
  }
  .ls{
    background-color: #207bee;
    border: 1px #207bee solid;
    color: #fff;
  }
  .ls:hover{
    background-color: #207bee;
    border: 1px #207bee solid;
    color: #fff;
  }
  .luis{
    background-color: #12b2ca;
    border: 1px #12b2ca solid;
    color: #fff;
  }
  .luis:hover{
    background-color: #1acee9;
    border: 1px #1acee9 solid;
    color: #fff;
  }
  .with-select .el-input-group__prepend{
    width: 70px;
    padding: 0 20px;
  }
  .el-selectq .el-select > .el-input{
    width: 100px;
    background-color: #f5f7fa;
    border-radius: 5px 0 0 5px;
  }
  .el-selectq .el-select .el-input__inner{
    background-color: #f5f7fa !important;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .register-input .el-input__inner{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
  }
  .widerl{
    width: 850px;
  }
</style>
